import { render, staticRenderFns } from "./MshipsGrid.vue?vue&type=template&id=07123d19"
import script from "./MshipsGrid.vue?vue&type=script&lang=js"
export * from "./MshipsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports